import BottomButtonArea from '../common/BottomButtonArea'
import ErrorScreenTopArea from '../common/ErrorScreenTopArea'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'

export default function DiscountOnlyLogoutScreen({
  toLogin,
}: {
  toLogin: () => void
}) {
  useGA4Pageview('slash_login_notall_notowner')
  return (
    <>
      <NavBar />
      <ErrorScreenTopArea
        title="未符合購買資格"
        content={
          <p className="babu-text-paragraph text-text600">
            此商品僅供 aifian 用戶購買，請使用 aifian 帳號登入。
          </p>
        }
      />
      <BottomButtonArea onClick={toLogin} variant="solid">
        重新登入
      </BottomButtonArea>
    </>
  )
}
